import React from 'react'
import { lozenges } from './CoalitionsList'
import Utilities from '../../../utils/Utilities'
import ObjectUtils from '../../../utils/ObjectUtils'
import { ICoalitionCount } from '../../../models/OutcomeController'

interface IProps {
  coalitionCounts: ICoalitionCount
  numCoalitionResults: number
}

class CoalitionsListBody extends React.Component<IProps> {
  public render(): JSX.Element {
    const { coalitionCounts, numCoalitionResults } = this.props

    const outcomeCountArray = ObjectUtils.mapToArray(coalitionCounts)

    const sortedArray = outcomeCountArray.sort((a, b): number => {
      const partiesA = a.key.split('-')
      const partiesB = b.key.split('-')

      if (partiesA[0] !== partiesB[0]) {
        return partiesA[0].localeCompare(partiesB[0])
      } else if (partiesA.length !== partiesB.length) {
        return partiesA.length - partiesB.length
      } else {
        return b.value - a.value
      }
    })

    console.log('sortedArray', sortedArray)

    return (
      <React.Fragment>
        {sortedArray.map(
          (keyValuePair): JSX.Element => {
            // const leaderKey = keyValuePair.key.split('-')[0]
            return (
              <tr key={keyValuePair.key}>
                <td>{lozenges(keyValuePair.key)}</td>
                <td>
                  <small className="text-muted">
                    <h4 className={'d-inline'}>
                      {Utilities.formatPercent(
                        coalitionCounts[keyValuePair.key] / numCoalitionResults,
                        0
                      )}{' '}
                    </h4>
                    of all minorities
                  </small>
                </td>
              </tr>
            )
          }
        )}
      </React.Fragment>
    )
  }
}

export default CoalitionsListBody
